module.exports = __webpack_public_path__ + "media/assets/images/maple/slider3-056542deb7ec91de9b24f60c639a30ba.jpg";